import React from "react";
import SectionHeading from "../components/SectionHeading";
import ServiceCard from "../components/ServiceCard";
import water from "../assets/water.jpg";
import halfframe from "../assets/halfframe.jpg";

const services = [
  {
    title: "Queen Rearing",
    sub: "Region Specific",
    description:
      "Locally raised queens selected with regional conditions in mind, giving South Sound beekeepers stock that is more aligned with the climate and forage cycle here.",
    accent: "from-amber-300 via-amber-500 to-orange-500",
  },
  {
    title: "Seasonal Nucs",
    sub: "Overwintered",
    description:
      "Nucleus colonies for newer or expanding beekeepers who want a steadier start than piecing together a colony from scratch.",
    accent: "from-lime-300 via-emerald-500 to-green-600",
  },
  {
    title: "Apiary Guidance",
    sub: "Professional Management",
    description:
      "Want a hive of bees in your garden, or 20 in your orchard? Get all of the benefits (and honey) out of your bees with none of the hassle. Support for new beekeepers who need simple, clear help on timing, colony growth, and basic management decisions.",
    accent: "from-sky-300 via-cyan-500 to-blue-500",
  },
  {
    title: "Swarm Management",
    sub: "Removal",
    description:
      "Do you have a swarm of bees or an unwanted nest in an old shed? Call us today for removal. We also handle wasps without Chemicals.",
    accent: "from-fuchsia-300 via-pink-500 to-rose-500",
  },
];

export default function ServicesPage() {
  return (
    <section className="pt-16 ">
      <div className="mx-auto max-w-6xl">
        <div className=" bg-forest p-6 text-white shadow-soft sm:col-span-2">
          {/* <div className="text-sm uppercase tracking-[0.25em] text-amber-200">
                Cedar & Comb
              </div>*/}
          <div className="text-3xl font-semibold leading-tight">Services</div>
          <div className="mt-3 text-sm leading-6 text-white/80">
            Purpose-built for a damp climate, steady forage windows, and
            beekeepers who want stock that fits the region.
          </div>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {services.map((service) => (
            <ServiceCard key={service.title} {...service} />
          ))}
        </div>
      </div>
      <div className="mt-12 grid md:grid-cols-2">
        <div>
          <img
            className="w-full h-[50vh] object-cover object-center"
            src={water}
            alt="Dandelion Bee"
          />
        </div>
        <div>
          <img
            className="w-full h-[50vh] object-cover object-center"
            src={halfframe}
            alt="Dandelion Bee"
          />
        </div>
      </div>
    </section>
  );
}
